// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-gate-enter-active[data-v-ef2ae8f8],.page-gate-leave-active[data-v-ef2ae8f8]{transition:all .5s ease-in-out}.page-gate-enter-from[data-v-ef2ae8f8],.page-gate-leave-to[data-v-ef2ae8f8]{opacity:0}.page-gate-leave-to[data-v-ef2ae8f8]{transform:translateY(10px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
